import React, { useState } from 'react';
import TogglerBody from '../../../../template/TogglerBody';
import { IoIosAddCircleOutline } from "react-icons/io";
import { useChanges } from "../../../../../hooks/useChanges";

const CustomMassageBlock = ({title, setTitle, massage, setMassage, header, setHeader,data}) => {
    const [isOnMonitor, setIsOnMonitor] = useState(data?.sendMessage)
    const [arrMas, setArrMas] = useState([1])
    const { addChangeToStore } = useChanges();

    const onChangeHeader = (e) => {
        setHeader(e.target.value)
        addChangeToStore({ key: 'embeds', value: [e.target.value, title, massage] })
    }

    const onChangeTitle = (e) => {
        setTitle(e.target.value)
        addChangeToStore({ key: 'embeds', value: [header, e.target.value, massage] })
    }

    const onChangeMassage = (e) => {
        setMassage(e.target.value)
        addChangeToStore({ key: 'embeds', value: [header, title, e.target.value] })
    }

    return (
        <div
            style={{maxWidth:'738px'}}
            className='status_block_wrap'>
            <div className='status_block_wrap_bg'></div>
            <img  className='status_block_wrap_img' src="/img/StatusBlock.svg" alt="" />
            <h3>Custom Rules Message</h3>
            <div 
            className='status_block_item'
            style={{borderBottom:'1px solid #8D99A3'}}
            >
                <div className='status_block_item_toggler'>
                    <TogglerBody
                    isOn={isOnMonitor}
                    setIsOn={setIsOnMonitor}
                    keyName='sendMessage'/>
                    <p>Use Rules Message</p>
                </div>
            </div>
            <h4 className='custom_rules_massage_title'>Embed Message Builder</h4>
            {arrMas.map((item,idx) => (
                <div key={idx} className='status_block_item'>
                        <div className='preview_verification_captcha custom_rules_wrap'>
                            <div className='custom_rules_wrap_title'>
                                <h3>
                                <img src="/img/CustomMassageHeader.svg" alt="" />
                                <input type="text" placeholder='Header' value={header} onChange={onChangeHeader} />
                                </h3>
                                <img className='custom_rules_wrap_title_img' src="/img/ImportCaptcha.svg" alt="" />
                            </div>
                                <input type="text" placeholder='Title' value={title} onChange={onChangeTitle} />
                                <input type="text" placeholder='Write your mesage here' value={massage} onChange={onChangeMassage} />
                                <img className='preview_verification_captcha_plug_footer' src="/img/ImportImg.svg" alt="" />
                        </div>
                </div>
            ))}
            <div className='status_block_item'>
                <button className='status_block_item_btn'> <IoIosAddCircleOutline className='status_block_item_btn_img' /> Add Embed</button>
            </div>
        </div>
    );
};

export default CustomMassageBlock;